import {customExpressionVisitor} from './customExpressionVisitor';
import {SourceCustomExpression} from '../../resource/detail/controls/synchronization/abstract-attribute-flow-control';
import {InputStream, CommonTokenStream} from '../../utils/interop/antlr4';
// @ts-ignore - Generated ANTLR files don't have TypeScript definitions
import {customExpressionLexer} from './customExpressionLexer.js';
// @ts-ignore - Generated ANTLR files don't have TypeScript definitions
import {customExpressionParser} from './customExpressionParser.js';

export class CustomExpressionParser {
  static parse(expression: string): SourceCustomExpression {
    const chars = new InputStream(expression);
    const lexer = new customExpressionLexer(chars);
    const tokens = new CommonTokenStream(lexer);
    const parser = new customExpressionParser(tokens);
    parser.buildParseTrees = true;
    const ctx = parser.start();
    const exception = CustomExpressionParser.getExceptions(ctx);
    if (exception !== false) {
      throw exception;
    }
    return new customExpressionVisitor().visitStart(ctx);
  }

  private static getExceptions(ctx): any {
    if (ctx.exception != null) {
      return ctx.exception;
    } else {
      if (!Array.isArray(ctx.children)) return false;
      for (let i = 0; i < ctx.children.length; i++) {
        const e = this.getExceptions(ctx.children[i]);
        if (e !== false) {
          return e;
        }
      }
    }
    return false;
  }
}
